export const icons = {
  checkCircleBroken: () => import("@icons/check-circle-broken.svg?react"),
  messageDotsSquare: () => import("@icons/message-dots-square.svg?react"),
  shoppingBag: () => import("@icons/shopping-bag.svg?react"),
  thumbsDownSolid: () => import("@icons/thumbs-down-solid.svg?react"),
  thumbsDown: () => import("@icons/thumbs-down.svg?react"),
  thumbsUpSolid: () => import("@icons/thumbs-up-solid.svg?react"),
  thumbsUp: () => import("@icons/thumbs-up.svg?react"),
  trash04: () => import("@icons/trash-04.svg?react"),
} as const;

